var CashNotEnoughShareRedirector = xClass("CashNotEnoughShareRedirector", BaseRedirector)
CashNotEnoughShareRedirector.prototype.getName = function () {
    var self = this
    return "happycoinNotEnough"
}
CashNotEnoughShareRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
CashNotEnoughShareRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    var um = UserManager.getInstance();
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }
    if (um.uid && param.inviteCode && param.shareId) {
        let http = HappycoinShareClickHttp.new();
        http.addEventListener(Events.kComplete, () => {
            Toast.make(getText("get.happycoin.help.succeed"));
        })
        http.addEventListener(Events.kError, (evt = {}) => {
            Toast.make(quickGetErrorText(evt.data, "链接已经失效！"));
        })
        http.load(param.inviteCode, param.shareId);
    }
    return true
}
module.exports = CashNotEnoughShareRedirector
